<template>
  <div class="box-comment">
    <img class="img-circle img-sm" :src="`http://localhost:9000/story/${comment.author.avatar.filename}`" alt="User Image" />
    <div class="comment-text">
      <span class="username">
        {{ comment.author.username }}
        <span class="text-muted pull-right">{{ formatDateTime(comment.created_at) }}</span>
      </span>
      {{ comment.comment }}
    </div>
  </div>
</template>
<script>
import { format, formatDistanceToNow, isToday, isYesterday } from "date-fns";
export default {
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  setup() {
    function formatDateTime(datetimeString) {
      if (isToday(datetimeString)) {
        return format(datetimeString, "h:mm a") + " Today";
      } else if (isYesterday(datetimeString)) {
        return format(datetimeString, "h:mm a") + " Yesterday";
      } else {
        const distance = formatDistanceToNow(datetimeString, {
          addSuffix: true,
        });
        return format(datetimeString, "h:mm a") + " " + distance;
      }
    }
    return {
      formatDateTime
    };
  },
}
</script>